import React, { memo } from "react";

function RecordingAlert({ handleCloseRecording, message }) {
  return (
    <>
      <div className="recording-bar" style={{}}>
        <div className="msg-icon">
          <i className="icon font-awesome-solid-pro va-exclamation-triangle mb-icon"></i>
        </div>
        <div className="message-text">
          <div className="msg-txt">
            <span>{message}</span>
          </div>
        </div>
        <div onClick={handleCloseRecording}>
          <a href className="brd-btn mb-btn">
            Dismiss
          </a>
        </div>
      </div>
    </>
  );
}

export default memo(RecordingAlert);
